<template>
  <div>
    <div class="page-title">Upload Receipt</div>
    <div class="detail">
      <upload
        :fileType="['jpeg', 'jpg', 'png']"
        @childByValue="childByValue"
        :imageurl="receiptFile"
      ></upload>
      <el-button type="primary" @click="onSubmit"> 遞交 Submit </el-button>
    </div>
    <div class="copyright-card">
      <copyrightCard></copyrightCard>
    </div>
  </div>
</template>

<script>
import { addApplicationUploadReceiptRequests } from "@/api/parent/application";
import upload from "@/components/upload";
import copyrightCard from "@/components/copyrightCard";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },

  components: {
    upload,
    copyrightCard,
  },

  data() {
    return {
      receiptFile: "",
    };
  },
  methods: {
    childByValue(value) {
      this.receiptFile = value;
    },
    onSubmit() {
      this.addApplicationUploadReceiptRequests();
    },
    addApplicationUploadReceiptRequests() {
      let from = {
        receiptFile: this.receiptFile,
      };
      addApplicationUploadReceiptRequests(this.id, from).then(() => {
        this.$message.success("upload successful");
        this.$router.push({ path: `/parent/application` });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  background-color: #fff;
  padding: 60px;
  margin-bottom: 20px;
}
.el-button--primary {
  width: auto;
  margin-top: 20px;
}
.copyright-card{
  background-color: #fff;
}
</style>